module.exports = require("core-js-pure/features/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/set-prototype-of.js
// module id = 346
// module chunks = 0